import { render, staticRenderFns } from "./BenefitAddLevelModal.vue?vue&type=template&id=261be608&scoped=true&"
import script from "./BenefitAddLevelModal.vue?vue&type=script&lang=ts&"
export * from "./BenefitAddLevelModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261be608",
  null
  
)

export default component.exports